import isNull from 'lodash/isNull'
import isNumber from 'lodash/isNumber'
import React from 'react'

import DropDown, { DropDownProps } from '@/common/components/DropDown'
import Form from '@/common/components/Form'
import RangeField, { RangeFieldProps } from '@/common/components/RangeField'
import useI18n from '@/common/hooks/useI18n'
import { APPLY } from '@/common/translation'
import { numberToString } from '@/common/utils/string'

import { SubmitButton } from './styled'

interface DropDownRangeProps extends Omit<RangeFieldProps, 'value'> {
  dropDownProps?: Omit<DropDownProps, 'children'>
  prefixLabel?: string
  value: [number, number]
}

const DropDownRange = ({
  dropDownProps,
  prefixLabel = '',
  label,
  value,
  decimals = 0,
  onChange,
  ...props
}: DropDownRangeProps) => {
  const { t } = useI18n()

  const onSubmit = (values: { range: [number, number] }) => {
    onChange?.(values.range)
  }

  return (
    <DropDown
      label={(value[0] === value[1] ? [value[0]] : [value[0], value[1]])
        .map(
          v =>
            prefixLabel +
            (!isNull(decimals) && isNumber(v)
              ? numberToString(v, { decimals })
              : isNumber(v)
              ? v
              : 'N/A')
        )
        .join(' - ')}
      width={260}
      destroyTooltipOnHide
      {...dropDownProps}
    >
      <Form
        className='px-20 py-16'
        defaultValues={{ range: value }}
        onSubmit={onSubmit}
      >
        <RangeField {...props} name='range' value={value} decimals={decimals} />
        <SubmitButton>{t(APPLY)}</SubmitButton>
      </Form>
    </DropDown>
  )
}

export default DropDownRange
